import { faXmark } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { useApiCall } from "../api/api";
import type { ProjectCheckIn } from "../api/dto/ProjectCheckIn";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const CloseCheckInModal: FC<{ checkIn: ProjectCheckIn; projectName: string }> = (props) => {
  const { closeCheckIn } = useApiCall();
  const refresh = useRefresh();

  const confirm = async () => {
    await closeCheckIn(props.checkIn.uuid);
    refresh();
  };

  return (
    <>
      <p>
        Weet je zeker dat je de check-in voor <strong>{props.projectName}</strong> wilt sluiten?
        Bezoekers kunnen daarna niet meer inchecken. Bezoekers die al zijn ingecheckt houden hun
        toegang tot die tijd verloopt.
      </p>
      <ModalFooter icon={faXmark} text={"Check-in sluiten"} onSubmit={confirm} />
    </>
  );
};
